package org.example.project.model

import kotlinx.serialization.Serializable

@Serializable
data class QueuePlayer(

    val uid: String = "",

    val username: String = "",

    val rating: Int = 1000,

    val joinedAt: Double = 0.0
)